import { useSelector } from 'react-redux';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { singleBreederProfileResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

export function useBreederProfileData() {
  const {
    server: { breederProfileId }
  } = useSelector(({ server }) => ({ server }));

  const { value: breeder, isFetching: isFetchingBreeder } = useResourceQuery(
    singleBreederProfileResourceDefinition(breederProfileId)
  );

  const shareMeta = breeder.share_meta;

  return {
    breeder,
    shareMeta,
    isFetchingBreeder
  };
}
